import styled from 'styled-components';
import Screen from '@/styles/Themes/Screen';
import { radius } from '@/styles/Themes/Metrics';
import { cssVars } from '@/styles/Themes/cssVars';
import { Vector } from '@/shared/images/icons/Vector';
import Palette from '@/styles/Themes/Palette';
import Text from '@/styles/Themes/Text';
import { Transition } from '@/styles/Themes/KeyFrames';

export const Container = styled.a`
    width: 100%;
    min-width: 240px;
    position: relative;
    flex-direction: column;
    border-radius: ${radius.small};
    background-color: ${cssVars.bg_white_dark3};
    ${Transition.normal};

    &:hover {
        box-shadow: ${cssVars.shadow_card_hover};
        ${Transition.normal};
    }
    ${Screen.ipad} {
        width: auto;
        flex: 1;
    }
    ${Screen.desktop} {
        width: calc(50% - 12px);
        flex: none;
    }
`;

export const Content = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 14px;
`;

export const Date = styled.div`
    display: flex;
    align-items: center;
    background-color: ${Palette.white.normal};
    color: ${Palette.gray.gray1};
    padding: 0 20px;
    border-radius: ${radius.button};
    height: 24px;
    margin-bottom: auto;
    ${Text.Full.medium.semibold}

    ${Screen.desktop} {
        height: 24px;
    }
`;

export const Title = styled.div`
    color: ${Palette.white.normal};
    ${Text.Mobile.large.semibold};
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin: 0 8px 12px;
    ${Screen.ipad} {
        ${Text.Full.large.semibold};
    }

    ${Screen.desktop} {
        max-width: 90%;
    }
`;

export const Location = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(13, 209, 197, 0.8);
    border-radius: 24px;
    color: ${Palette.white.normal};
    padding: 2px 20px;
    ${Text.Full.medium.medium}
    line-height: 1.4;
    max-width: 100%;

    ${Screen.desktop} {
        max-width: 90%;
    }
`;

export const LocationCity = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const LocationImg = styled(Vector)`
    display: flex;
    margin-right: 5px;
`;
